const AppConsts = {
  userManagement: {
    defaultAdminUserName: 'admin',
  },
  localization: {
    defaultLocalizationSourceName: 'SaaScada',
  },
  authorization: {
    encrptedAuthTokenName: 'enc_auth_token',
  },
  appBaseUrl: 'http://localhost:12345',
  remoteServiceBaseUrl: process.env.VUE_APP_PORTAL_BACKEND_BASE_URL,
  theme: {
    light: {
      primary: '#0d6591', // SaaScada
      // primary: '#00204E', // Example Customer A
      // primary: '#D24944', // Example Customer R
      secondary: '#E340CE', // SaaScada
      // secondary: '#ff6e00', // Example Customer A
      // secondary: '#424242', // Example Customer R
      background: '#0d6591', // SaaScada
      // background: '#00204E', // Example Customer A
      // background: '#D24944', // Example Customer R
      error: '#FF5252',
      info: '#2196F3',
      success: '#4CAF50',
      warning: '#FFC107'
    },
    dark: {
      primary: '#0d6591', // SaaScada
      // primary: '#00204E', // Example Customer A
      // primary: '#D24944', // Example Customer R
      secondary: '#961185', // SaaScada
      // secondary: '#313131', // Example Customer A
      // secondary: '#313131', // Example Customer R
      background: '#0f4159', // SaaScada
      // background: '#00204E', // Example Customer A
      // background: '#D24944', // Example Customer R
      error: '#a80000',
      info: '#2196F3',
      success: '#4CAF50',
      warning: '#FFC107'
    }
  }
}
export default AppConsts;